export { default as SapBondStatusSlot } from './SapBondStatusSlot';
